import {createApi} from '@reduxjs/toolkit/query/react';
import urls from 'urls';
import {customBaseQuery} from '~/common/rtk-query/queries';
import {GiftCardRetailer} from '~/QuickEcards/types/egift';

interface GetRetailersResponse {
  status: string;
  products: GiftCardRetailer[];
}

export const eGiftApi = createApi({
  reducerPath: 'eGiftApi',
  baseQuery: customBaseQuery(),
  endpoints: (builder) => ({
    getRetailers: builder.query<GiftCardRetailer[], void>({
      query: () => ({
        method: 'GET',
        url: urls.get('ajax_bhn_products'),
      }),
      transformResponse: (data: GetRetailersResponse) => {
        const {products} = data;
        // Sort top_retailers to the front of the array
        window.fabricTemplate.create_flow_config?.top_retailers.forEach((retID, idx) => {
          const retailerInProductArrIdx = products.findIndex((p) => p.product_config_id === retID);
          if (retailerInProductArrIdx < 0) return;
          const retailerInProductArr = products[retailerInProductArrIdx];
          products.splice(retailerInProductArrIdx, 1);
          products.splice(idx, 0, retailerInProductArr);
        });
        return products;
      },
    }),
  }),
});

export const {useGetRetailersQuery, useLazyGetRetailersQuery} = eGiftApi;
